import AWSProvider from './AWSProvider';

export default {
    create() {
        return new AWSProvider();
    }
};
